import type { IOrderChatRepository } from '@domain/data-contracts/order-chat-repository.interface';
import type {
  OrderChatMessage,
  OrderChatMessageKind,
  OrderChatOrder,
} from '@domain/models/order-chat.interface';

export class OrderChatService {
  public constructor(private readonly repository: IOrderChatRepository) {}

  public listOrders(): Promise<readonly OrderChatOrder[]> {
    return this.repository.listOrders();
  }

  public getMessages(orderId: string): Promise<readonly OrderChatMessage[]> {
    return this.repository.getMessages(orderId);
  }

  public sendMessage(
    orderId: string,
    clientMessageId: string,
    kind: OrderChatMessageKind,
    body: string,
  ): Promise<OrderChatMessage> {
    return this.repository.sendMessage(orderId, clientMessageId, kind, body);
  }
}
